import React from 'react';
import { Navbar,NavDropdown,Button,Form,FormControl } from 'react-bootstrap';
import left from '../img/icons_texteditor/015-left.png';
import * as Icon from 'react-bootstrap-icons';
import { TextField } from '@material-ui/core';

export default class Toolbar extends React.Component{
  
render(){
 function H1(){
   if(document.getElementById("h1").style.backgroundColor=="grey"){
    document.getElementById("h1").style="background-color:transparent";
   }else{
    document.getElementById("h1").style="background-color:grey";

   }
  }
    return(
        <div >
<Navbar bg="light" expand="lg">
<Button variant="light"><Icon.Arrow90degLeft  size={30}/></Button>
<Button variant="light"><Icon.Arrow90degRight size={30}/></Button>
<Button variant="light" id="h1" onClick={H1} ><Icon.TypeH1 size={30}/></Button>
<Button variant="light"><Icon.TypeH2 size={30}/></Button>
<Button variant="light"><Icon.TypeH3 size={30}/></Button>
<NavDropdown title="Normal" id="basic-nav-dropdown">
        <NavDropdown.Item >Normal</NavDropdown.Item>
        <NavDropdown.Divider />
        <NavDropdown.Item >Titre</NavDropdown.Item>
        <NavDropdown.Divider />
        <NavDropdown.Item >Sous-titre</NavDropdown.Item>
        
      </NavDropdown>
      <NavDropdown title="Arial" id="basic-nav-dropdown">
        <NavDropdown.Item >Action</NavDropdown.Item>
        <NavDropdown.Item >Another action</NavDropdown.Item>
        <NavDropdown.Item >Something</NavDropdown.Item>
        <NavDropdown.Divider />
      </NavDropdown>

      <Button variant="light"><Icon.Dash size={20}/></Button>
<input type="number" style={{width:"55px"}} value="15"/>
<Button variant="light"><Icon.Plus size={20}/></Button>
<Icon.GripHorizontal/>
<Button variant="light"><Icon.TypeBold size={30}/></Button>
<Button variant="light"><Icon.TypeItalic size={30}/></Button>
<Button variant="light"><Icon.TypeStrikethrough size={30}/></Button>
<Button variant="light"><Icon.TypeUnderline size={30} /></Button>
<Button variant="light"><Icon.Type size={30}/></Button>
<Button variant="light"><Icon.Fonts size={30}/></Button>
<Button variant="light"><Icon.TextCenter size={30} /></Button>
<Button variant="light"><Icon.TextLeft size={30}/></Button>
<Button variant="light"><Icon.TextRight size={30}/></Button>
<Button variant="light"><Icon.TextParagraph size={30}/></Button>
     

<Button variant="light"><Icon.ListOl size={30}/></Button>
<Button variant="light"><Icon.ListCheck size={30}/></Button>
<Button variant="light"><Icon.TextIndentLeft size={30}/></Button>
<Button variant="light"><Icon.TextIndentRight size={30}/></Button>
<Button variant="light"><Icon.TextareaT size={30}/></Button>

      </Navbar>




        </div>
        
    );
   
    
}
   
}


